export const currencyFormatter = ({ value }) => {
  if (value !== null && value !== undefined) {
    return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
  }
  return "";
};
